import React, { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {useInView} from "react-intersection-observer";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitleButton from "../components/includes/HeaderBranchTitleButton";
import { LoginAfterCheckLogin,isNull,PassedMonthsCode,GetClassStatus } from "../../components/common/Common";
import arrowIcon from "../../img/icon/icon-arrow-right-g.svg";
import "../../css/style.css";

//비밀번호 찾기
const ClassSet = () => {
  LoginAfterCheckLogin(2);  //로그인 상태 점검
  const branch_idx = Number(localStorage.getItem('branch_idx'));
  const navigate = useNavigate();
  const {ref, inView} = useInView();

  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  const [varTotalCount,setTotalCount] = useState(0);
  const [varTotalPage,setTotaPage] = useState(0);
  const [varPageNum,setPageNum] = useState(1);

  const [varClassList,setClassList] = useState([]);
  const [varSearchName,setSearchName] = useState("");

  const [varSemesterIndex,setSemesterIndex] = useState(0);
  const [varSemesterList,setSemesterList] = useState([]);

  const [varStartMode,setStartMode] = useState(true);

  //학기내역 가져오기
  const GetClassList = async() => {
    const sendData = {branch_idx:branch_idx,mode:1,sm_idx:varSemesterIndex,searchName:varSearchName,pageNum:varPageNum,pageSize:10};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_class_list`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      let bfound = false;
      setStartMode(false);
      if(datas.retvalue === 1) {
        //학기
        if(datas.semesters.length > 0) setSemesterList(datas.semesters);

        //클래스
        const classList = datas.results;
        if(classList.length > 0){
          bfound = true;
          const classList = datas.results;
          GetChildrenList(classList);
          const totalcount = datas.totalcount;
          setTotalCount(totalcount);
          const totalpage = Math.ceil(totalcount/10);
          setTotaPage(totalpage);
        }
      }
      if(!bfound) {
        setTotalCount(0);
        setTotaPage(0);
        setClassList([]);
      }
    });
  }
  //클래스 내역별 원생 목록 추가
  const GetChildrenList = async(classList) => {
    for(var i=0; i < classList.length; i++) {
      const classData = classList[i];
      classData.childrens = [];
      let childrenArray = [];
      const sendData = {cl_idx:classData.cl_idx};
      console.log(sendData);
      await axios.post(`${process.env.REACT_APP_HOST}/branch_get_class_children_list`,sendData).then((res) => {
        const datas = res.data;
        console.log(datas);
        if(datas.retvalue === 1) {
          const childrens = datas.results;
          for(var j=0; j < childrens.length; j++) {
            let childData = childrens[j];
            let newData = {idx:childData.ch_idx,name:childData.ch_name,months:PassedMonthsCode(childData.ch_birthday),state:childData.clc_status};
            childrenArray.push(newData);
          }
          console.log(childrenArray);
        }
      });
      classData.childrens = childrenArray;
      classList[i] = classData;
    }
    setClassList(classList);
  }
  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});
    //현재 사용중인 학기가 존재하면
    if(!isNull(localStorage.getItem('semesterIndex'))) {
      const semesterIndex = Number(localStorage.getItem('semesterIndex'));
      setSemesterIndex(semesterIndex);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log(varSemesterIndex);
    if(!varStartMode) GetClassList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varSemesterIndex]);

  useEffect(() => {
    if(inView && varPageNum < varTotalPage) {
      setPageNum((prev) => prev+1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[inView]);

  useEffect(() => {
    GetClassList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[varPageNum]);

  //검색명
  const onChangeSearchNameHandler = (e) => {
    const sname = e.currentTarget.value;
    setSearchName(sname);
  }

  //검색시작
  const onSearchHandler = (e) => {
    e.preventDefault();
    /* if(varSearchName === "") {
      alert('검색할 원생명이나 학부모명을 먼저 입력하세요.'); return false;
    } */
    GetClassList();
  }

  //클래스 내용보기
  const onClassDetailHandler = (e,cl_idx) => {
    localStorage.setItem('backPageUrl','/Branch/ClassSet');
    navigate(`/Branch/ClassDetail/${cl_idx}`);
  }

  //클래스 수업 내역 보기
  const onClassInformationHandler = (e,cl_idx) => {
    localStorage.setItem('backPageUrl','/Branch/ClassSet');
    localStorage.setItem('class_information',0);
    localStorage.setItem('class_study_index',0);
    navigate(`/Branch/ClassInformation/${cl_idx}`);
  }

  //학기선택
  const onSelectSemesterIndex = (e) => {
    const sm_idx = Number(e.currentTarget.value);
    setSemesterIndex(sm_idx);
    setPageNum(1);
    localStorage.setItem('semesterIndex',sm_idx);
  }

  return (
    <div className="vh-content class-setting-wrap">
      <HeaderBranchTitleButton varPageTitle={'클래스 설정'} varBackString={'none'} varButtonTitle="수강재개" varButtonLink={'/Branch/ToggleStudySet'}/>
      <div className="vh-content-body">
        <div className="cl-search-form">
          <div className="center-wrap">
            {/* 학기 선택 */}
            <div className="sem-select-wrap">
							<label>학기 선택</label>
							<select name="" value={varSemesterIndex} onChange={e=>onSelectSemesterIndex(e)}>
								<option value={0}>전체 학기</option>
                {varSemesterList.map((semester,i)=>(
                  <option key={'semester_'+i} value={semester.sm_idx}>{semester.sm_name}</option>
                ))}
							</select>
						</div>
            {/* 원생및 학부모이름으로 검색 */}
            <div className="search-wrap">
							<input type="text" name="search_name" className="search-input" placeholder="원생명, 학부모명으로 검색" value={varSearchName} onChange={e=>onChangeSearchNameHandler(e)}/>
							<button type="button" onClick={e=>onSearchHandler(e)}>검색</button>
						</div>
            <div className="search-ok-con">
              <div className="top-line2">
								<p>전체 {varTotalCount}건</p>
								<button onClick={e=>onClassDetailHandler(e,0)}>클래스 추가</button>
							</div>
              {varClassList.map((classes,i)=>(
                <div key={'classes_'+i} className="con-box">
                  <div className="class-card-top">
                    <p>{classes.cl_name}</p>
                    <button onClick={e=>onClassInformationHandler(e,classes.cl_idx)} className="btn-setting"><img src={arrowIcon} alt="" /></button>
                    <div className="txt-box">
                      <div className="flex">
                        <p>학기</p>
                        <div>{classes.sm_name}</div>
                      </div>
                      <div className="flex">
                        <p>교실</p>
                        <div>{classes.cr_type===1?"마마몽떼":"플라이"} {classes.cr_name}</div>
                      </div>
                      <div className="flex">
                        <p>원생</p>
                        <div>{`정원 : ${classes.cl_childrens}, 등록수 : ${classes.tchildrens}`}</div>
                      </div>
                    </div>
                  </div>
                  <div className="class-card-bottom">
                    <ul>
                      {classes.childrens.map((childs,j)=>(
                        <li key={'childs_'+j} className={GetClassStatus(childs.state)}>{`${childs.name}(${childs.months})`}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
              {varPageNum < varTotalPage?<div ref={ref}>Load More</div>:null}
            </div>
          </div>
        </div>
      </div>
    </div>	
  );
}
export default ClassSet;